import { SiteSettings, ApplicationFeatures, SiteFlags } from "../../../DTOs";
import { basicValidation } from "../basicValidation";

export const siteFieldValidation = {
    site: {
        // 32 max characters, no hyphens (pg)
        // 3 characters minimum, and no underscores (azure blob containers)
        id: (value: string) => validateSiteId(value),
        loginName: (value: string) => validateSiteId(value),
        settings: (value: SiteSettings) =>
        {
            if (!value) return false;
            if (!basicValidation.validateBoolean(value.enabled)) return false;
            if (!basicValidation.validateBoolean(value.hideSurveyEmailAddresses)) return false;
            if (!basicValidation.validateTextString(value.apiVideoKey, 0, 100)) return false;
            if(!basicValidation.validateFlags(ApplicationFeatures, value.features)) return false;
            if(!basicValidation.validateFlags(SiteFlags, value.flags)) return false;

            return true;
        },
    }
}

function validateSiteId (value: string): boolean
{
    // Although postgres allows _ in identifiers, Azure Blob Storage does not
    return typeof value === 'string'
        && value !== null
        && value !== undefined
        && new RegExp("^[a-z]{1}[a-z0-9]{2,31}$").test(value);
}